import type { VehicleDetailsState } from '../types';

export const vehicleDetailsInitialState: VehicleDetailsState = {
    isLoading: false,
    error: null,

    vin: '',
    year: 0,
    make: '',
    model: '',
    trim: '',
    stockNumber: '',
    chromeId: '',
    imageUrl: '',
    bodyStyle: '',
    title: '',
    listedPrice: 0,
    retailPrice: 0,
    invoicePrice: 0,
    wholesalePrice: 0,
    cost: 0,
    savings: 0,
    exteriorColor: '',
    exteriorColorFull: '',
    interiorColor: '',
    interiorColorFull: '',
    interiorMaterial: [],
    engine: '',
    engineSize: '',
    transmission: '',
    transmissionFull: {
        extendedDescription: '',
        gearCount: 0,
        manufacturer: '',
        oemOptionCode: '',
        primaryDescription: '',
        type: ''
    },
    fuel: '',
    cityFuelEconomy: 0,
    highwayFuelEconomy: 0,
    combinedFuelEconomy: 0,
    odometer: 0,
    inventoryDate: '',
    inventoryStatus: '',
    inServiceDate: '',
    dealerId: '',
    history: '',
    packages: [],
    warranties: [],
    condition: undefined,
    destinationCharge: null,
    standardFeatures: undefined,
    installedOptionalEquipment: undefined
};
